import { render, staticRenderFns } from "./MainCustomer.vue?vue&type=template&id=8cc5568e"
import script from "./MainCustomer.vue?vue&type=script&lang=js"
export * from "./MainCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports